var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-window mt-3 mr-3 border bd-e4 px-3"},[_c('HeaderWindow',{attrs:{"title":_vm.$t('obj_health_records.lbl_health_information')},on:{"onClose":_vm.onClose}}),_c('div',{staticClass:"mt-3 px-3"},[_c('InformationForm',{attrs:{"disease":_vm.disease,"edit":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }